{
  "OninboundalertingPara": "Vous pouvez activer des alarmes lorsque les appels entrants restent en alerte trop longtemps.",
  "OntalktimePara": "Vous pouvez également activer des alarmes lorsqu'un appel atteint un seuil de temps de conversation.",
  "OninboundalertingLabel": "Sur les alertes entrantes, terminé :",
  "OntalktimeLabel": "On Talk Time Over :",
  "OninboundalertingEnabledHiddenlabel": "Le réglage de l'alerte sur les appels entrants est-il activé ?",
  "OntalktimeEnabledHiddenlabel": "Le paramètre de dépassement du temps de conversation est-il activé ?",
  "OninboundalertingPlaceholder": "15s",
  "OntalktimePlaceholder": "5m 0s",
  "CallStateThresholds_SectionHeader": "Seuils d'état d'appel",
  "NAME": "CallStateThresholds"
}